import { RepositoryFactory } from "repository/RepositoryFactory";

let Stats = RepositoryFactory.get("stats");

export const fetchRestaurantStats = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getRestaurantStats(payload);
      dispatch({
        type: "GET_RESTAURANT_STATS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchOrderAnalysis = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getOrderAnalysis(payload);
      const response = Object.values(data?.data);
      dispatch({
        type: "FETCH_ORDER_ANALYSIS_SUCCESS",
        payload: response,
      });
      resolve(response);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchRevenueEarned = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getRevenueEarned(payload);
      dispatch({
        type: "FETCH_REVENUE_EARNED_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchSellersCharts = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getSellersCharts(payload);

      dispatch({
        type: "FETCH_SELLERS_CHARTS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchVisitCards = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getVisits(payload);
      dispatch({
        type: "FETCH_VISIT_CARDS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchPeakHours = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getPeakHours(payload);

      dispatch({
        type: "FETCH_PEAK_HOURS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchTopMerchants = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getTopMerchants(payload);

      dispatch({
        type: "FETCH_TOP_MERCHANTS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchPaymentMethod = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getPaymentMethod(payload);

      dispatch({
        type: "FETCH_PAYMENT_METHODS_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
export const fetchTotalCustomer = (payload) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Stats.getTotalCustomer(payload);

      dispatch({
        type: "FETCH_TOTAL_CUSTOMER_SUCCESS",
        payload: data?.data,
      });
      resolve(data?.data);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
